// extracted by mini-css-extract-plugin
export default {"calendarEventsMobileMenu":"CalendarEventsMobileMenu_calendarEventsMobileMenu__oQ2Sq"};